<template>
    <div
        v-click-away="() => (isOpen = false)"
        class="inline-flex w-[135px] select-none flex-col rounded-[6px] border border-black bg-[#F4F5F7] px-[14px] py-[6px]"
    >
        <button
            type="button"
            class="flex w-full items-center justify-between gap-2"
            @click="isOpen = !isOpen"
        >
            <span class="flex items-center gap-2">
                <span class="text-[14px] leading-[142%] text-[#161E2E]">{{
                    current.flag
                }}</span>
                <span
                    class="text-[12.25px] font-medium leading-[142%] text-[#161E2E]"
                    >{{ current.name }}</span
                >
            </span>

            <svg
                class="h-4 w-4 shrink-0 transition-transform text-[#161E2E]"
                :class="isOpen ? 'rotate-180' : ''"
                viewBox="0 0 20 20"
                fill="none"
                stroke="currentColor"
            >
                <path
                    d="M6 8l4 4 4-4"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        </button>

        <div v-if="isOpen" class="mt-[6.5px] flex flex-col gap-[6.5px]">
            <a
                v-for="lang in others"
                :key="lang.code"
                class="flex items-center gap-2 rounded-[4px] px-1 py-1 text-[#161E2E] opacity-60 hover:bg-black/5 hover:opacity-100"
                :href="toHref(lang.code)"
                @click="isOpen = false"
            >
                <span class="text-[14px] leading-[142%]">{{ lang.flag }}</span>
                <span class="text-[12.25px] font-medium leading-[142%]">{{
                    lang.name
                }}</span>
            </a>
        </div>
    </div>
</template>
<script setup lang="ts">
import { computed, ref } from "vue";
import { usePage } from "@inertiajs/vue3";
import { useTranslations } from "@/composables/useTranslations";

type Lang = { code: string; name: string; flag: string };

const isOpen = ref(false);

const { t } = useTranslations();
const page = usePage();

const languages = computed<Lang[]>(() => [
    { code: "en", name: t("vue.english_lang"), flag: "🇺🇸" },
    { code: "cs", name: t("vue.czech_lang"), flag: "🇨🇿" },
]);

const currentLocale = computed(() => (page.props as any).locale || "en");

const current = computed(() => {
    return (
        languages.value.find((l) => l.code === currentLocale.value) ||
        languages.value[0]
    );
});

const others = computed(() =>
    languages.value.filter((l) => l.code !== current.value.code),
);

const toHref = (code: string) => `/language/${code}`;
</script>
